export enum ApiResources {
    // Pages
	Pages = 'pages',
	Page = 'page',

	// User
	Me = 'me',
}
